import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '@screen';
import styled from 'styled-components';

/**
 * Styled text component for channel title in pause ad modal.
 * Displays the channel name with bold font styling.
 */
const PauseAdEventEventTitle = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['bold']};
  font-size: ${Screen.widthRatio * 32}px;
  margin-bottom: ${Screen.widthRatio * 10}px;
`;

export default PauseAdEventEventTitle;
